// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/main.css
// module id = 2847
// module chunks = 7